import React from "react";

export default function AppShell({ children, variant = "page", className = "" }) {
  const cls = [
    "app-shell",
    variant === "split" ? "app-shell--split" : "",
    variant === "form" ? "app-shell--form" : "",
    className,
  ].filter(Boolean).join(" ");

  return <div className={cls}>{children}</div>;
}

export function AppPageHeader({ title, subtitle, action, eyebrow }) {
  return (
    <header className="app-page-header">
      <div className="app-page-header-copy">
        {eyebrow && <p className="app-page-eyebrow">{eyebrow}</p>}
        <h1 className="app-page-title">{title}</h1>
        {subtitle && <p className="app-page-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="app-page-header-action">{action}</div>}
    </header>
  );
}
